import { PRIO } from '../../../constants';
import { PrioHealthErrorLevel } from '../../../models/Zendesk';
import { PrioHealthHighestErrorLevelState } from '../reducers/prioHealthHighestErrorLevel';

export interface PrioHealthHighestErrorLevelAction {
  type: string;
  newState: PrioHealthHighestErrorLevelState;
}

export const UPDATE_PRIO_HEALTH_HIGHEST_ERROR_LEVEL =
  PRIO + 'UPDATE_PRIO_HEALTH_HIGHEST_ERROR_LEVEL';

export const updatePrioHealthHighestErrorLevel = (
  highestErrorLevel: PrioHealthErrorLevel
) => ({
  type: UPDATE_PRIO_HEALTH_HIGHEST_ERROR_LEVEL,
  newState: { highestErrorLevel },
});
